import { Action, createReducer, on } from '@ngrx/store';
import {
    loadAvailableCerts,
    loadAvailableCertsSuccess,
    loadAvailableSkills,
    loadAvailableSkillsSuccess,
    loadQualifications,
    loadQualificationsSuccess,
    loadQualificationsFailure,
    loadQualificationChanges,
    loadQualificationChangesSuccess,
    loadQualificationChangesFailure,
    resetQualificationChanges,
    getRequirementsFromUD,
    getRequirementsFromUDSuccess,
    getRequirementsFromUDFailure,
    loadAvailableCertsFailure,
    loadAvailableSkillsFailure,
    updateJobLevelAlternatives
} from '../actions/job-qualifications.actions';
import { JobQualificationsState } from '../state/job-qualifications.state';

const initialState: JobQualificationsState = {
    jobId: 0,
    qualifications: undefined,
    availableSkills: [],
    availableCerts: [],
    effectiveAlternativeCertifications: [],
    jobLevelAlternativeCertifications: [],
    changes: undefined,
    sideDrawerLoading: false,
    isLoading: false,
    isChangesLoading: false
};

const reducer = createReducer(
    initialState,

    on(
        loadQualifications,
        (state): JobQualificationsState => ({
            ...state,
            isLoading: true
        })
    ),

    on(
        loadQualificationsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            isLoading: false,
            qualifications: action.qualifications,
            effectiveAlternativeCertifications: action.qualifications.alternativeCertifications || [],
            jobLevelAlternativeCertifications: action.qualifications.alternativeCertifications || []
        })
    ),

    on(
        loadQualificationsFailure,
        (state): JobQualificationsState => ({
            ...state,
            isLoading: false,
            qualifications: undefined
        })
    ),

    on(
        loadQualificationChanges,
        (state): JobQualificationsState => ({
            ...state,
            isChangesLoading: true
        })
    ),

    on(
        loadQualificationChangesSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            isChangesLoading: false,
            changes: action.changes
        })
    ),

    on(
        loadQualificationChangesFailure,
        (state): JobQualificationsState => ({
            ...state,
            isChangesLoading: false
        })
    ),

    on(
        resetQualificationChanges,
        (state): JobQualificationsState => ({
            ...state,
            changes: undefined
        })
    ),

    on(
        loadAvailableSkills,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: true
        })
    ),

    on(
        loadAvailableSkillsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false,
            availableSkills: action.skills
        })
    ),

    on(
        loadAvailableSkillsFailure,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false
        })
    ),

    on(
        loadAvailableCerts,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: true
        })
    ),

    on(
        loadAvailableCertsSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false,
            availableCerts: action.certs
        })
    ),

    on(
        loadAvailableCertsFailure,
        (state): JobQualificationsState => ({
            ...state,
            sideDrawerLoading: false
        })
    ),

    on(
        getRequirementsFromUD,
        (state): JobQualificationsState => ({
            ...state,
            isLoading: true
        })
    ),

    on(
        getRequirementsFromUDSuccess,
        (state, action): JobQualificationsState => ({
            ...state,
            isLoading: false,
            qualifications: action.qualifications,
            effectiveAlternativeCertifications: action.qualifications.alternativeCertifications || [],
            jobLevelAlternativeCertifications: action.qualifications.alternativeCertifications || []
        })
    ),

    on(
        getRequirementsFromUDFailure,
        (state): JobQualificationsState => ({
            ...state,
            isLoading: false
        })
    ),

    on(
        updateJobLevelAlternatives,
        (state, action): JobQualificationsState => ({
            ...state,
            jobLevelAlternativeCertifications: action.alternatives
        })
    )
);

export function jobQualificationsReducer(state: JobQualificationsState | undefined, action: Action) {
    return reducer(state, action);
}
